// ---------------------------------------------------------------------------
// Panel, ported from the design system (R7)
//
// The surface every subject sits on: a title, an optional subtitle and
// actions, and a body that a table can fill edge to edge (flush).
// ---------------------------------------------------------------------------

import { html, type TemplateResult } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';

import { cx, node, present } from './helpers.js';

export interface PanelProps {
  title?: unknown;
  subtitle?: unknown;
  actions?: unknown;
  /** A table fills the body edge to edge. */
  flush?: boolean;
  className?: string;
}

export function panel(p: PanelProps, content?: unknown): TemplateResult {
  const head =
    present(p.title) || present(p.actions)
      ? html`<header class="sdr-panel__head">
          <div class="sdr-panel__titles">
            ${present(p.title) ? html`<h2 class="sdr-panel__title">${node(p.title)}</h2>` : null}
            ${present(p.subtitle) ? html`<p class="sdr-panel__subtitle">${node(p.subtitle)}</p>` : null}
          </div>
          ${present(p.actions) ? html`<div class="sdr-panel__actions">${node(p.actions)}</div>` : null}
        </header>`
      : null;
  return html`<section
    class=${cx('sdr-panel', p.className)}
    aria-label=${ifDefined(typeof p.title === 'string' ? p.title : undefined)}
  >
    ${head}
    <div class=${cx('sdr-panel__body', p.flush && 'sdr-panel__body--flush')}>${node(content)}</div>
  </section>`;
}
